/**
 * FilterPills — pills on md+ screens, native <select> on mobile.
 *
 * Props:
 *   options: [{ k: string, label: string }]
 *   value: currently selected key
 *   onChange: (k) => void
 *   testid: optional root testid (buttons get `${testid}-${k}` on both variants)
 *   className: extra classes for the wrapper
 *   trailing: optional right-side node (only rendered on desktop pill row)
 */
export default function FilterPills({ options, value, onChange, testid, className = "", trailing }) {
  const rootId = testid || "filter";
  return (
    <div className={`w-full ${className}`} data-testid={rootId}>
      {/* Mobile: dropdown */}
      <div className="md:hidden">
        <select
          value={value}
          data-testid={`${rootId}-select`}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 text-sm">
          {options.map(o => (
            <option key={o.k} value={o.k} data-testid={`${rootId}-option-${o.k}`}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
      {/* Desktop: pill row */}
      <div className="hidden md:flex md:items-center md:gap-2 md:flex-wrap">
        {options.map(o => (
          <button key={o.k}
            type="button"
            data-testid={`${rootId}-${o.k}`}
            onClick={() => onChange(o.k)}
            className={value === o.k ? "btn-primary text-xs" : "btn-ghost text-xs"}>
            {o.label}
          </button>
        ))}
        {trailing}
      </div>
    </div>
  );
}
